import React, {Component} from 'react';
import { Tabs } from '../../../../common/elements';
import { FAQContent } from '../';

class FaqPage extends Component {

    state = { currentSection: 1 };

	// renderTabs() {
    //
	// 	const { currentSection } = this.state;
    //
	// 	return (
	// 		<Tabs>
	// 			<button className={ currentSection === 1 && `current` } onClick={ () => this.setState( { currentSection: 1 } ) }>Already a member</button>
	// 			<button className={ currentSection === 2 && 'current' } onClick={ () => this.setState( { currentSection: 2 } ) }>Looking for a non-exec</button>
	// 		</Tabs>
	// 	);
	// };

	render () {
		return (
			<div className="help-text">
					{/*{this.renderTabs()}*/}
					<h4 className="h4">Frequently Asked Questions</h4>
          {
              this.state.currentSection === 1 ?
	              <FAQContent content="member" />
	              :
	              <FAQContent content="non-member" />
          }
			</div>
		);
	};
}

export default FaqPage;



// WEBPACK FOOTER //
// src/client/components/site/features/help/faq/FaqPage.js